import src from "IMAGE";
export default { src, width: 4037, height: 1214, blurWidth: 0, blurHeight: 0};
